import { image } from "d3";
import i18n from '@/i18n/i18n.js'

export const TABLE_ITEMS = [
    {
        desc: i18n.t("other.a1374"),
        key: 'image',
        type: 'image',
    }, 
    {
        desc: 'sku',
        key: 'variationSku',
        type: 'input',
    }, 
    
    {
        desc: i18n.t("other.a3235"),
        key: 'price',
        type: 'input',
    },
    {
        desc: i18n.t("other.a3236"),
        key: 'supplyPrice',
        type: 'default',
    },
    {
        desc: 'productId',
        key: 'productId',
        type: 'default',
    },
    {
        desc: i18n.t("other.a3237"),
        key: 'cusCode',
        type: 'default',
    },
    {
        desc: i18n.t("other.a310"),
        key: 'stock',
        type: 'default',
    },

]